import cn from 'classnames'
import {
  IRevenue,
  TComplexSectionData,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { useJbpSettings } from 'legacy/lut/features/partner360/jbpSettings'
import { useMemo } from 'react'

import { Loader } from 'core-components/library/loader'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'
import { useTableActions } from '../../../hooks/useTableActions'
import { StyledTable } from '../../styledComponents/styledTable/StyledTable'
import { Title } from '../../styledComponents/title/Title'
import { changeRevenueComputedFields } from '../helpers/changeRevenueComputedFields'
import { isInconsistency } from '../helpers/financialInconsistencies/isInconsistency'
import { getRevenueFullViewColumns } from '../helpers/getRevenueFullViewColumns'
import styles from '../Revenue.module.scss'

import { keyField, visibleKeys } from './configs'

interface IProps {
  fYear: number
  fQuarter: number
  data: IRevenue[]
  updateFormData: (data: TComplexSectionData) => void
  netNdpValue: ActualsValueTypes
}

export const PolyRevenueFullViewByMarkets = ({
  data,
  updateFormData,
  fQuarter,
  fYear,
  netNdpValue,
}: IProps) => {
  const {
    isLoaded,
    jbpSettings: { fYearELT: yearFromJbpSettings },
  } = useJbpSettings()
  const { onChangeByKey } = useTableActions<IRevenue>({
    updateFormData: updateFormData,
    data: data,
    changeComputedFieldsFn: changeRevenueComputedFields,
  })

  const columns = useMemo(
    () =>
      getRevenueFullViewColumns({
        netNdpValue,
        onChange: onChangeByKey(keyField),
        currentYear: fYear,
        currentFQuarter: fQuarter,
        isInconsistency: isInconsistency(data),
        yearFromJbpSettings,
      }),
    [onChangeByKey, data, fYear, fQuarter, yearFromJbpSettings, netNdpValue]
  )

  const items = useMemo(() => {
    return data
      .filter((el) => visibleKeys.includes(el.Key))
      .sort((a, b) => {
        return visibleKeys.indexOf(a.Key) - visibleKeys.indexOf(b.Key)
      })
  }, [data])

  if (!isLoaded) {
    return <Loader />
  }

  return (
    <div>
      <Title
        variant="withBackground"
        text={getFormedEltTranslation('section-global-roll-up-by-market')}
        translationReplaceParams={[
          {
            key: '{netNdp}',
            value: netNdpValue.toUpperCase(),
          },
        ]}
      />
      <StyledTable<IRevenue>
        columns={columns}
        items={items}
        keyField={keyField}
        classes={{ td: styles.tdWidth, header: cn(styles.header, styles.fullRevenue) }}
      />
    </div>
  )
}
